import React from 'react';
import { Menu, Button } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    DashboardOutlined,
    SettingOutlined,
    DatabaseOutlined,
    CloudOutlined,
    ExperimentOutlined,
    ThunderboltOutlined,
    SlidersOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    RobotOutlined
} from '@ant-design/icons';
import { useUser } from '../../contexts/UserContext';

const AppSidebar: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, hasPermission, sidebarCollapsed, setSidebarCollapsed } = useUser();

    // 所有可能的菜单项
    const allMenuItems = [
        {
            key: '/dashboard',
            icon: <DashboardOutlined />,
            label: '仪表板',
            permission: 'dashboard:view',
        },
        {
            key: '/stations',
            icon: <SettingOutlined />,
            label: '场站管理',
            permission: 'station:manage',
        },
        {
            key: '/historical-data',
            icon: <DatabaseOutlined />,
            label: '历史数据管理',
            permission: 'historical-data:view',
        },
        {
            key: '/weather-prediction',
            icon: <CloudOutlined />,
            label: '气象预测',
            permission: 'weather-prediction:view',
        },
        {
            key: '/weather-data',
            icon: <CloudOutlined />,
            label: '气象数据管理',
            permission: 'weather-data:manage',
        },
        {
            key: '/models',
            icon: <ExperimentOutlined />,
            label: '模型管理',
            permission: 'model-management:manage',
        },
        {
            key: '/prediction',
            icon: <ThunderboltOutlined />,
            label: '功率预测',
            permission: 'power-prediction:manage',
        },
        {
            key: '/prediction-evaluation',
            icon: <RobotOutlined />,
            label: '预测评定',
            permission: 'prediction-evaluation:view',
        },
    ];

    // 根据用户权限过滤菜单项
    const getFilteredMenuItems = () => {
        if (!user) return [];

        if (user.role === 'dashboard-viewer') {
            // 数据大屏用户只能看仪表板
            return allMenuItems.filter(item => item.key === '/dashboard');
        }

        return allMenuItems.filter(item =>
            hasPermission(item.permission) || hasPermission('all')
        );
    };

    const menuItems = getFilteredMenuItems();

    const handleMenuClick = (item: any) => {
        navigate(item.key);
    };

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div className="logo" style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: sidebarCollapsed ? 'center' : 'space-between',
                padding: sidebarCollapsed ? '16px 8px' : '16px'
            }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <ThunderboltOutlined style={{ marginRight: sidebarCollapsed ? 0 : 8, fontSize: '20px' }} />
                    {!sidebarCollapsed && <span>功率预测系统</span>}
                </div>
                <Button
                    type="text"
                    icon={sidebarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                    onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                    className="sidebar-collapse-btn"
                    style={{
                        color: 'rgba(255, 255, 255, 0.8)',
                        fontSize: '16px',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                />
            </div>
            <Menu
                theme="dark"
                mode="inline"
                selectedKeys={[location.pathname]}
                items={menuItems}
                onClick={handleMenuClick}
                inlineCollapsed={sidebarCollapsed}
                style={{ flex: 1 }}
            />
        </div>
    );
};

export default AppSidebar; 